import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';

const ActionHourSectionSkeleton = ({ showDownloads = true, showTip = true }) => (
  <div className="background-light-gray py-5">
    <Row>
      <Col xs={12}>
        <h2 className="text-center mb-4">
          <Skeleton width={300} />
        </h2>
      </Col>
    </Row>

    <Row className="justify-content-center mb-4">
      <Col xs={12} lg={8}>
        <div style={{ aspectRatio: '16/9', width: '100%' }}>
          <Skeleton height="100%" />
        </div>
      </Col>
    </Row>

    <Row className="justify-content-center mb-4">
      <Col xs={12} lg={8}>
        <Skeleton count={3} />
      </Col>
    </Row>

    <Row className="justify-content-center mb-5">
      <Col xs={12} md={6} lg={4}>
        <Skeleton height={48} />
      </Col>
    </Row>

    {showDownloads && (
      <Row className="justify-content-center mb-4">
        <Col xs={12} lg={8}>
          <h3 className="text-center mb-4">
            <Skeleton width={150} />
          </h3>
          <Row className="justify-content-center text-center">
            {[1, 2, 3].map((_, index) => (
              <Col xs={6} md={4} key={index} className="mb-3">
                <div className="d-flex flex-column align-items-center">
                  <Skeleton circle width={60} height={60} className="mb-2" />
                  <Skeleton width={100} />
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    )}

    {showTip && (
      <Row className="justify-content-center">
        <Col xs={12} lg={8}>
          <Card className="border-2">
            <CardBody>
              <h5 className="font-weight-bold mb-3">
                <Skeleton width={60} />
              </h5>
              <Skeleton count={3} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    )}
  </div>
);

export default ActionHourSectionSkeleton;
